<section class="full-evrn-demo section section__bg-gradient-parent">
  <div class="full-evrn-demo__gradient section__bg-gradient" aria-hidden="true"></div>

  <div class="full-evrn-demo__inner container">
    <h2 class="full-evrn-demo__title title">Full EVRN demo</h2>

    <app-youtube-player
      poster="assets/demo/evrn-demo-poster.png"
      autoplay
      aspectRation="2 / 1"
      videoUrl="https://www.youtube.com/watch?v=oqUi6G_opQU"
    />
  </div>
</section>
